const mutations = {
    PRODUCT_DONATION_LOADING: state => {
        state.productDonationStatus = "loading";
    },
    PRODUCT_DONATION_SUCCESS: (state) => {
        state.productDonationStatus = "success";
    },
    ADD_DONATION(state, product) {
        const foundDonation = state.donationCart.find(currentProduct => currentProduct.product_id == product.product_id);

        if (!foundDonation) {
            state.donationCart.push({
                product_id: product.product_id,
                product_title: product.product_name,
                product_price: parseFloat(product.product_price),
                product_quantity: 1,
                product_akv: product.product_voucher_eligible,
                product_totalPrice: parseFloat(product.product_price),
                product_court: product.product_court_names,
                product_donation: true,
            });
        }
    },
    UPDATE_DONATION_TOTAL: (state) => {
        let total = 0;

        if(state.donationCart.length > 0){
            total = state.donationCart[0].product_price;
        }

        // state.donationTotal = total;
        Vue.set(state, "donationTotal", total);
    },
    REMOVE_DONATION(state, product) {
        const index = state.donationCart.findIndex(currentProduct => currentProduct.product_id == product.product_id);
        if(index >= 0){
            state.donationCart.splice(index, 1);
        }
    },
    PRODUCT_DONATION_ERROR: (state, err) => {
        let errors = err.error ? err.error : {};

        state.productDonationStatus = "error";
        state.productDonationErrors.record(errors);
    },
    CLEAR_COUPON_ERRORS: state => {
        state.productDonationStatus = "";
        state.productDonationErrors.clear();
    },
    RESET_STATE: state => {
        Object.assign(state, state.initialState());
    },
};

export default mutations;
